import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const initialState = {};
export const zigbeeNodesSlice = createSlice({
    name: 'zigbee_nodes',
    initialState,
    reducers: {
        zigbeeNodesCleared: s => {
            for (const key in s) {
                delete s[key];
            }
            ;
        },
        zigbeeNodeUpdated: (s, action) => {
            s[action.payload.id] = action.payload;
        },
        zigbeeNodeDeleted: (s, action) => {
            delete s[action.payload];
        },
        zigbeeNodesReplaced: (s, action) => {
            return action.payload;
        },
        zigbeeNodesUpdateEndpointGroups: {
            reducer: (s, action) => {
                const g = action.payload;
                if (g.zigbee_node_id in s) {
                    if (g.endpoint_id in s[g.zigbee_node_id].endpoints) {
                        s[g.zigbee_node_id].endpoints[g.endpoint_id].groups = g.groups;
                    }
                }
            },
            prepare: (zigbee_node_id, endpoint_id, groups) => {
                return {
                    payload: { foo: 44, zigbee_node_id, endpoint_id, groups }
                };
            }
        }
    },
    extraReducers: builder => {
        builder
            .addCase(setDefinitions, (s, action) => {
            const newState = {};
            for (const o of action.payload.zigbee_nodes) {
                newState[o.id] = o;
            }
            return newState;
        });
    },
});
export const { zigbeeNodesCleared, zigbeeNodeUpdated, zigbeeNodeDeleted, zigbeeNodesReplaced, zigbeeNodesUpdateEndpointGroups } = zigbeeNodesSlice.actions;
export default zigbeeNodesSlice.reducer;
